import { render, staticRenderFns } from "./GeoProducts.vue?vue&type=template&id=8ebc8792&"
import script from "./GeoProducts.vue?vue&type=script&lang=js&"
export * from "./GeoProducts.vue?vue&type=script&lang=js&"
import style0 from "./GeoProducts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports